export default "__VITE_PUBLIC_ASSET__2fd6c8d9__"